import { GETLANGUAGES, SETLANGUAGE } from "../constants/CountryLang";
export const getLanguagesAction = (languages) => ({
  type: GETLANGUAGES,
  payload: languages,
});
export const setLanguageAction = (language) => ({
  type: SETLANGUAGE,
  payload: language,
});
